import { useContainerContext } from '@front10/utils';
import React from 'react';
import { mergeDeep } from '../../helpers/utils';

const LocaleContext = React.createContext<Record<string, $TSFixMe>>({});

export function LocalizationProvider(props: React.PropsWithChildren<Record<string, $TSFixMe>>) {
  const { localizationData } = useContainerContext();
  const value = React.useMemo(() => {
    return mergeDeep({}, localizationData, props.value);
  }, [localizationData, props.value]);
  return <LocaleContext.Provider value={value}>{props.children}</LocaleContext.Provider>;
}

export function useLocalizationData() {
  return React.useContext(LocaleContext);
}
